<template>
  <div class="h-100">
    <main role="main" class="h-100">
        <common-master-table
          primary-key="itemSerialId"
          table-no="mstItem"
          table-api="master/item"
          ref="commonMasterTable"
          :editable="editableMixin.item"
          :addable="editableMixin.item"
          :mapping-no="`ie-item`"
          socket-entity="ITEM_SOCKET"
        />
    </main>
  </div>
</template>

<script>
import CommonMasterTable from '../custom-components/CommonMasterTable'
import RouterUtils from '../../_helpers/router.util'
export default {
  components: {
    // コンポーネント分割化
    CommonMasterTable
  },
  data() {
    return {
      removeKeys: [],
      updateQueryStr: ''
    }
  },
  beforeRouteUpdate(to, from) {
    if (to.query && to.query.hasOwnProperty('limit') && Object.keys(to.query).length === 1) {
      RouterUtils.correctTableRowsLimitParam(to.query)
      this.$refs.commonMasterTable.initData()
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/mst-tables/ItemMaster.vue